export default __webpack_public_path__ + "static/Genuine Parts – Vertical 400x400-9bb0223239c5afa48137fe4e35c23570.svg";